import React, { useContext } from 'react';

//components
import WidgetButton from './WidgetButton/WidgetButton';

//enums
import { WidgetType } from  '@/interfaces/widgetPanel';



const FileWidget = () => {

    function handleFileClick(){
        (window as any).functions?.mediaLibrary?.('Files')
    }

    return (
        <div className="widget-panel-item">
            <WidgetButton type={WidgetType.FILE} onClick={handleFileClick} />
        </div>
    )
}
export default FileWidget